import api from './api';
import { compressImageFile } from '@/utils/imageCompression';

const base = '/api/admin';

export const getDashboard = () => api.get(`${base}/dashboard`);
export const getAgentsStatus = () => api.get(`${base}/agents-status`);
export const getAiBrainLogs = () => api.get(`${base}/agents/ai-brain/logs`);
export const runAiBrainAgent = () => api.post(`${base}/agents/ai-brain/run`);
export const getAnalytics = (days = 30) => api.get(`${base}/analytics`, { params: { days } });

const crud = (entity) => ({
  list: (params) => api.get(`${base}/${entity}`, { params }),
  get: (id) => api.get(`${base}/${entity}/${id}`),
  create: (data) => api.post(`${base}/${entity}`, data),
  update: (id, data) => api.put(`${base}/${entity}/${id}`, data),
  remove: (id) => api.delete(`${base}/${entity}/${id}`),
});

export const cities = crud('cities');
export const zones = crud('zones');
export const pois = crud('pois');
const uploadImage = async (url, fieldName, file, options) => {
  const compressedFile = await compressImageFile(file, options);
  const data = new FormData();
  data.append(fieldName, compressedFile);
  return api.post(url, data);
};

export const resetPOIVisit = (id, playerId) => api.post(`${base}/pois/${id}/reset-visit`, playerId ? { playerId } : {});

export const uploadPOIImage = (id, file) =>
  uploadImage(`${base}/pois/${id}/photo`, 'photo', file, {
    maxWidth: 1600,
    maxHeight: 1200,
    maxSizeBytes: 1.5 * 1024 * 1024,
  });

export const badges = crud('badges');
export const generateBadgeImage = (data) => api.post(`${base}/badges/generate-image`, data, { timeout: 120000 });
export const missions = crud('missions');
export const partners = crud('partners');
export const uploadPartnerLogo = (id, file) =>
  uploadImage(`${base}/partners/${id}/logo`, 'logo', file, {
    maxWidth: 1000,
    maxHeight: 1000,
    maxSizeBytes: 1024 * 1024,
  });

export const offers = crud('offers');
export const uploadOfferImage = (id, file) =>
  uploadImage(`${base}/offers/${id}/image`, 'image', file, {
    maxWidth: 1400,
    maxHeight: 1000,
    maxSizeBytes: 1.2 * 1024 * 1024,
  });

export const aiSuggestZone = (text) => api.post(`${base}/ai-suggest/zone`, { text });
export const aiSuggestPOI = (text) => api.post(`${base}/ai-suggest/poi`, { text });

export const getUsers = (params) => api.get(`${base}/users`, { params });
export const getPlayers = (params) => api.get(`${base}/players`, { params });
export const getRedemptions = (params) => api.get(`${base}/redemptions`, { params });
export const updateRedemptionStatus = (id, status) => api.put(`${base}/redemptions/${id}/status`, { status });
export const getFraudLogs = (params) => api.get(`${base}/fraud-logs`, { params });

export const suggestions = {
  list: (params) => api.get(`${base}/suggestions`, { params }),
  pendingCount: () => api.get(`${base}/suggestions/pending-count`),
  generate: () => api.post(`${base}/suggestions/generate`),
  approve: (id, data) => api.post(`${base}/suggestions/${id}/approve`, data),
  reject: (id, data) => api.post(`${base}/suggestions/${id}/reject`, data),
  backlog: (id, data) => api.post(`${base}/suggestions/${id}/backlog`, data),
  researchPOIs: (data) => api.post(`${base}/suggestions/research-pois`, data, { timeout: 600000 }),
  delete: (id) => api.delete(`${base}/suggestions/${id}`),
};

export const getNotifications = (params) => api.get(`${base}/notifications`, { params });
export const markNotificationRead = (id) => api.put(`${base}/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.put(`${base}/notifications/mark-all-read`);
export const deleteNotification = (id) => api.delete(`${base}/notifications/${id}`);
